// extracted by mini-css-extract-plugin
module.exports = {"root":"InputAdornment_mantine_root__g8Cvw","adornment-start":"InputAdornment_mantine_adornment-start__eTf6f","adornment-end":"InputAdornment_mantine_adornment-end__63d7U"};